
    <template>
  <v-expansion-panel>
    <v-expansion-panel-content>
      <template v-slot:header>
        <div>Spec Label Logo</div>
      </template>
      <v-card>
            <v-container>
      <v-layout wrap>
        <v-flex
          xs12

        > 
           <v-layout row wrap>
             <h5 class='title'>Current Logo</h5>
          <img v-if='imageURL' :src="imageURL"  />
           </v-layout>
          <input
           type='file'
           accept="image/*"
           @change="uploadImage"
          />
        </v-flex>

       
      </v-layout>
    </v-container>
      </v-card>
    </v-expansion-panel-content>
    <v-expansion-panel-content>
      <template v-slot:header>
        <div>Magento Settings</div>
      </template>
      <v-card>
            <v-container>
      <v-layout wrap>
      
        
       
      </v-layout>
    </v-container>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>




<script>
 import { mapFields } from 'vuex-map-fields';
const fb = require('../firebaseConfig.js')
export default {
    data(){
      return{
      }
    },
       computed: {
    ...mapFields([
      'imageURL'
    ]),
  },
    methods : {

      uploadImage(e){
        var storageRef = fb.storage.ref();
        var logoRef = storageRef.child(e.target.files[0].name)
        logoRef.put(e.target.files[0]).then((snapshot)=> {
        snapshot.ref.getDownloadURL().then((url)=> { 
          this.imageURL = url
          fb.SettingsCollections.doc("logoURL").update({
          reference : "gs://tech-reuse.appspot.com/"+ snapshot.ref.fullPath
        })
          }) 
        
        //save gs ref to settings collections
});
      }
    },
 beforeRouteEnter (to, from, next) {
        fb.SettingsCollections.doc("logoURL").get().then((doc)=> {
         
          var gsReference = fb.storage.refFromURL(doc.data().reference)
          gsReference.getDownloadURL().then((url)=> { 

            next(vm => vm.imageURL = url)
            }) 
          
        })
   fb.SettingsCollections.doc("UniqueID").get().then(()=> {
          
           })
  },
    created() {

    }
}
</script>
